export const numbersOnly = '^[0-9]+$';
export const noNumbers = '^[^\\d]+$';
export const startWithNumber = '^[0-9]+.*$';
export const numberTwelveDigits = '^[0-9]{12}$';

export const isPersonalDataFormValid = component => {
  return (
    component.state.anrede !== undefined &&
    component.state.ort &&
    component.state.plz &&
    component.state.land &&
    component.refs.form.checkValidity &&
    component.refs.form.checkValidity()
  );
};
